/**
 * cookie.js
 */

export const setCookie = (name, value, days) => {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value};${expires};path=/`;
}


export const getCookie = (name) => {
  var cookieList = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieList ? cookieList.pop() : "";
}